import { render, staticRenderFns } from "./tasks-item.vue?vue&type=template&id=6097f6a4"
import script from "./tasks-item.vue?vue&type=script&lang=js"
export * from "./tasks-item.vue?vue&type=script&lang=js"
import style0 from "./tasks-item.vue?vue&type=style&index=0&id=6097f6a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports